<!-- This wrapper shows the background without any animations on it-->
<div class="backGroundWrapper">

  <!--
  We need the fadeIn animation on the container
  to prevent the slideOutLeft animation from running at the initial render.
  -->
  <div class="contentWrapper" @fadeIn>

    <!-- Keep the groups on screen to store the scrollPosition? -->
    @if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_HOME) {
      <tun-settings-home-panel
    [@carousel]="{
      value: animationDirection,
      params: {
        duration: CAROUSEL_DURATION
      }
    }"
      class="fullContainer"
      (openSettingsView)="onOpenSettingsView($event)">
    </tun-settings-home-panel>
  }

  @if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_LANGUAGE) {
    <tun-settings-language-panel
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
    class="fullContainer"
    (back)="onBack()">
  </tun-settings-language-panel>
}

@if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_BANLIST) {
  <tun-settings-banlist-panel
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer"
  (back)="onBack()">
</tun-settings-banlist-panel>
}

@if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_MUSICRIGHTS) {
  <tun-settings-music-rights-panel
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer"
  (back)="onBack()">
</tun-settings-music-rights-panel>
}

@if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_SONGREQUEST) {
  <tun-settings-song-request-panel
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer"
  (back)="onBack()">
</tun-settings-song-request-panel>
}

@if ((settingsView$ | async) == SETTINGS_VIEW.SETTINGS_VIEW_DESKTOP_APP) {
  <tun-settings-desktop-app-panel
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer"
  (back)="onBack()">
</tun-settings-desktop-app-panel>
}

</div>


</div>
